import React, { useState, useEffect } from "react";
import "./add-affiliates.css";
import DataTable from "react-data-table-component";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../../axios/axios";
import { message } from "antd";
import Modal from "react-bootstrap/Modal";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import { CSVLink } from "react-csv";
import moment from "moment";
import { adminConfig } from "../../../utils/adminConfig";

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
      backgroundColor: "#004aad",
      borderRadius: "10px 10px 0 0",
    },
  },
  footRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
      backgroundColor: "#004aad",
      borderRadius: "10px 10px 0 0",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#fff",
      //backgroundColor: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};

const CommissionPlan = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [commisionList, setcommisionList] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [pagination, setPagination] = useState({
    limit: 10,
    page: 1,
    totalPage: 0,
    totalRows: 0,
  });
  const [viewData, setViewData] = useState([]);
  const [show, setShow] = useState(false);
  const [showReport, setshowReport] = useState(false);
  const [msgShow, setmsgShow] = useState(false);
  const [viewReportData, setViewReportData] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCloseReport = () => setshowReport(false);
  const handleShowReport = () => setshowReport(true);
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [csvData, setCsvData] = useState([]);

  const getList = async () => {
    try {
      setLoading(true);
      await axios
        .get(
          `/get-affliate-with-commission-lists?limit=${limit}&page=${page}&search=${search}`,
          adminConfig()
        )
        .then((res) => {
          setcommisionList(res.data.data);
          setLoading(false);
          setPagination(res.data.pagination);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const handlePerRowsChange = (newPerPage) => {
    setLimit(newPerPage);

    setPage(1);
  };

  const changePage = (newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, search]);

  const modalopenForView = (id) => {
    handleShow();

    setLoading(true);
    axios
      .get(`/get-affliate-users/${id}`, adminConfig())
      .then((res) => {
        setViewData(res.data.data);
        handleShow();
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const modalopenForViewReport = async (id) => {
    try {
      setLoading(true);
      await axios
        .get(`/user/commissions/${id}`, adminConfig())
        .then((res) => {
          setViewReportData(res.data.data);
          handleShowReport();
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.error(err);
        });
    } catch (error) {
      setLoading(false);

      console.error(error);
    }
  };

  const paidMark = async (id, userId) => {
    setLoading(true);
    await axios
      .get(`/user/commissions-paid/${id}`, adminConfig())
      .then((res) => {
        modalopenForViewReport(userId);
        setLoading(false);
        message.success("Commission Paid Successfully");
        setmsgShow(true);
        setTimeout(() => {
          setmsgShow(false);
        }, 3000);
      })
      .catch((err) => {
        setLoading(false);
        message.error("Commission Unpaid");
        console.error(err);
      });
  };

  const columns = [
    {
      name: "Affiliate Name",
      selector: (row) => {
        return <span>{row.belongsToUser?.name}</span>;
      },
      sortable: true,
      width: "300px",
    },
    {
      name: "Members",
      selector: (row) => {
        return (
          <div className="edit_delete_but">
            <button
              type="button"
              className="edit_buttt butttton"
              onClick={() => modalopenForView(row._id)}
            >
              View Members
            </button>
          </div>
        );
      },
      sortable: true,
      width: "300px",
    },
    {
      name: "Report",
      selector: (row) => {
        return (
          <div className="edit_delete_but">
            <button
              type="button"
              className="edit_buttt butttton"
              onClick={() => modalopenForViewReport(row.belongsToUser.id)}
            >
              View Report
            </button>
          </div>
        );
      },
      sortable: true,
      width: "300px",
    },
    {
      name: "Affiliate ID",
      selector: (row) => row.id,
      sortable: true,
      width: "400px",
    },
    {
      name: "Action",
      selector: (row) => {
        return (
          <div className="edit_delete_but">
            <button
              type="button"
              className="edit_buttt butttton"
              onClick={() => {
                history.push(`/edit-affiliate/${row._id}`);
              }}
            >
              Change Affiliate Members
            </button>
          </div>
        );
      },
      sortable: true,
      width: "300px",
    },
  ];

  const columns_members = [
    {
      name: "Member Name",
      selector: (row) => row.name,
      sortable: true,
      width: "300px",
    },
    {
      name: "Email ID",
      selector: (row) => row.email,
      sortable: true,
      width: "220px",
    },
    {
      name: "Phone Number",
      selector: (row) => row.phone,
      sortable: true,
      width: "220px",
    },
    {
      name: "Plan",
      selector: (row) => row.plan,
      sortable: true,
      width: "250px",
    },

    {
      name: "Commission",
      selector: (row) => row.commission,
      sortable: true,
      width: "190px",
    },
  ];

  const columns_report = [
    {
      name: "Description",
      selector: (row) => row.name,
      sortable: true,
      width: "25%",
    },
    {
      name: "Amount($)",
      selector: (row) => row.amount,
      sortable: true,
      width: "13%",
    },
    {
      name: "Received On",
      selector: (row) => new Date(row.createdAt).toLocaleDateString(),
      sortable: true,
      width: "20%",
    },
    {
      name: "Enrolled User",
      selector: (row) => {
        return (
          <>
            <p>
              <small>Name : {row.sourceUser.name}</small>
            </p>
            <p>
              <small>Email : {row.sourceUser.email}</small>
            </p>
          </>
        );
      },
      sortable: true,
      width: "32%",
    },
    {
      name: "Paid",
      selector: (row) => {
        return (
          <>
            {row.isPaid ? (
              <>
                <input
                  type="checkbox"
                  defaultChecked
                  checked
                  readOnly
                  name=""
                  id=""
                />
              </>
            ) : (
              <>
                <input
                  type="checkbox"
                  onClick={() => paidMark(row.id, row.userId)}
                  name=""
                  id=""
                />
              </>
            )}
          </>
        );
      },
      sortable: true,
      width: "10%",
    },
  ];

  const exportCSV = () => {
    setLoading(true);
    axios
      .get(
        `/get-csv-affliate-with-commission-lists?search=${search}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const csvData = res.data.data.map((member) => ({
            AffiliateName: member.belongsToUser?.name,
            AffiliateID: member.id,
            Code: member.code,
            Date: moment(member.createdAt).format("MM-DD-YYYY"),
            Status: member.status ? "Active" : "Inactive",
          }));
          setCsvData(csvData);
          setTimeout(() => {
            document.getElementById("csv-download-link").click();
            setLoading(false);
          }, 2000);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const csvHeaders = [
    { label: "Affiliate Name", key: "AffiliateName" },
    { label: "Affiliate ID", key: "AffiliateID" },
    { label: "Code", key: "Code" },
    { label: "Date", key: "Date" },
    { label: "Status", key: "Status" },
  ];

  return (
    <LoadingOverlay active={loading} spinner text="Loading ...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <div className="ar_count_card d-flex">
                  <h3>Affiliate Member Details</h3>
                  <div className="ar_count">{pagination.totalRows}</div>
                </div>

                <div className="filter_section">
                  <div className="input-group filter_fields">
                    <div className="search_field">
                      <input
                        placeholder="Type name or Affiliate Id"
                        type="text"
                        id="form1"
                        className="form-control"
                        onChange={(e) => {
                          setQuery(e.target.value);
                        }}
                        value={query}
                      />
                    </div>

                    <Button
                      className="search_button"
                      variant="primary"
                      onClick={() => {
                        setSearch(query);
                        setPage(1);
                      }}
                    >
                      Search
                    </Button>

                    <Button
                      className="search_button"
                      variant="secondary"
                      onClick={() => {
                        setSearch("");
                        setQuery("");
                        setPage(1);
                      }}
                    >
                      Clear Filter
                    </Button>
                  </div>
                  <div className="filter_btns">
                    <Button
                      className="btn btn-primary search_button"
                      onClick={exportCSV}
                    >
                      Export CSV
                    </Button>
                    <CSVLink
                      data={csvData}
                      headers={csvHeaders}
                      filename={`affiliate_members_details.csv`}
                      className="hidden"
                      id="csv-download-link"
                      target="_blank"
                    />
                  </div>
                </div>

                <div className="plan_data">
                  <DataTable
                    columns={columns}
                    data={commisionList}
                    pagination
                    striped
                    responsive
                    customStyles={customStyles}
                    subHeaderAlign="right"
                    subHeaderWrap
                    paginationDefaultPage={page}
                    paginationServer
                    paginationTotalRows={pagination.totalRows}
                    paginationPerPage={limit}
                    paginationRowsPerPageOptions={[10, 15, 20, 40]}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={changePage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          show={show}
          onHide={handleClose}
          size="lg"
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header>
            <Modal.Title>Members Details</Modal.Title>
            <button type="button" class="close" onClick={handleClose}>
              <span aria-hidden="true">×</span>
              <span class="sr-only">Close</span>
            </button>
          </Modal.Header>
          <Modal.Body className="modal-lg">
            <DataTable
              columns={columns_members}
              data={viewData}
              pagination
              striped
              responsive
              customStyles={customStyles}
              subHeaderAlign="right"
              subHeaderWrap
            />
          </Modal.Body>
        </Modal>

        <Modal show={showReport} onHide={handleCloseReport} size="xl">
          <Modal.Header>
            <Modal.Title>Commission Report</Modal.Title>
            <button type="button" class="close" onClick={handleCloseReport}>
              <span aria-hidden="true">×</span>
              <span class="sr-only">Close</span>
            </button>
          </Modal.Header>
          {msgShow ? (
            <>
              <p class="text-center text-success">
                Commission Paid Successfully!
              </p>
            </>
          ) : (
            <></>
          )}
          <Modal.Body className="modal-xl">
            <DataTable
              columns={columns_report}
              data={viewReportData}
              pagination
              striped
              responsive
              customStyles={customStyles}
              subHeaderAlign="right"
              subHeaderWrap
            />
          </Modal.Body>
        </Modal>
      </div>
    </LoadingOverlay>
  );
};

export default CommissionPlan;
